import { render, staticRenderFns } from "./GKTable.vue?vue&type=template&id=6cb90c92&scoped=true&"
import script from "./GKTable.vue?vue&type=script&lang=js&"
export * from "./GKTable.vue?vue&type=script&lang=js&"
import style0 from "./GKTable.vue?vue&type=style&index=0&id=6cb90c92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb90c92",
  null
  
)

export default component.exports